// Largest-remainder (Hamilton) apportionment: split an integer `total` across
// `weights` so the parts are whole numbers that sum exactly to `total`
// (e.g. 100 across three equal owners → 34/33/33, never 33/33/33). Used both
// for % → share counts and counts → displayed % in the ownership node, so the
// numbers always reconcile.
export function allocateByLargestRemainder(total: number, weights: readonly number[]): number[] {
  const weightSum = weights.reduce((sum, w) => sum + Math.max(0, w), 0);
  if (total <= 0 || weightSum <= 0) return weights.map(() => 0);

  const exact = weights.map((w) => (Math.max(0, w) / weightSum) * total);
  const floors = exact.map((v) => Math.floor(v));
  const allocated = floors.reduce((sum, v) => sum + v, 0);
  let remaining = total - allocated;

  const byRemainderDesc = exact
    .map((v, index) => ({ index, frac: v - Math.floor(v) }))
    .sort((a, b) => b.frac - a.frac);

  const result = [...floors];
  byRemainderDesc.forEach(({ index }) => {
    if (remaining > 0) {
      result[index] += 1;
      remaining -= 1;
    }
  });
  return result;
}
